import { c as _c } from "react/compiler-runtime";
import { logger } from "@justhome/common";
import { usePostMaximumBudget } from "@justhome/api-core";
import { Loader } from "@justhome/react-ui";
import usePartnerContext from "@lib/hooks/usePartnerContext";
import useApplicationContext from "@modules/application/hooks/useApplicationContext";
import mapFormToMaximumBudget from "@modules/application/lib/budgetCheck/mapFormToMaximumBudget";
import { BudgetCheckFormValues } from "@modules/application/lib/budgetCheck/types";
import { FC, useEffect } from "react";
import { FormStepComponent } from "../FormSteps/FormSteps";
const BudgetCheckLoading: FC<FormStepComponent<BudgetCheckFormValues>> = t0 => {
  const $ = _c(19);
  const {
    value,
    onNext,
    onPrevious
  } = t0;
  const {
    state,
    dispatch
  } = useApplicationContext();
  const {
    partner
  } = usePartnerContext();
  let t1;
  if ($[0] !== dispatch || $[1] !== onNext) {
    t1 = maximumBudget => {
      dispatch({
        type: "SET_MAXIMUM_BUDGET",
        maximumBudget
      });
      onNext();
    };
    $[0] = dispatch;
    $[1] = onNext;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== onPrevious) {
    t2 = err => {
      logger.error("Failed to post maximum budget", err);
      onPrevious();
    };
    $[3] = onPrevious;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = {
      onSuccess: t1,
      onError: t2
    };
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    mutate: postMaximumBudget
  } = usePostMaximumBudget(t3);
  let t4;
  if ($[8] !== partner?.id || $[9] !== postMaximumBudget || $[10] !== state.lead?.id || $[11] !== value) {
    t4 = () => {
      const body = mapFormToMaximumBudget(value as BudgetCheckFormValues, state.lead?.id, partner?.id);
      postMaximumBudget({
        body
      });
    };
    $[8] = partner?.id;
    $[9] = postMaximumBudget;
    $[10] = state.lead?.id;
    $[11] = value;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== partner || $[14] !== postMaximumBudget || $[15] !== state.lead || $[16] !== value) {
    t5 = [state.lead, partner, value, postMaximumBudget];
    $[13] = partner;
    $[14] = postMaximumBudget;
    $[15] = state.lead;
    $[16] = value;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  useEffect(t4, t5);
  let t6;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex flex-col items-center"><span className="flex gap items-center"><Loader size="md" /><span className="text-title-1 opacity-75">Dies kann bis zu 10 Sekunden dauern</span></span><h1 className="text-app-h1 my-3s">Ergebnisse werden geladen</h1></div>;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};
export default BudgetCheckLoading;